export default "__VITE_ASSET__dea85f13__"